'use strict';

var $ = require('jquery');

var searchButton = $('#header .search'),
    searchBlock = $('#header .search-block'),
    mobileNavigationToggle = $('#header .mobile-menu-toggle .mobile-menu'),
    navigationList = $('#header #site-navigation .navigation'),
    searchInput = $('#header #search-field'); 

$(function() {

    // Desktop Search Button click
    $(searchButton).click(function() {
        if (!$(this).hasClass('open')) {
            openSearchElement();
        } else {
            closeSearchElement();
        }
    });

    $(mobileNavigationToggle).click(function() {
        if (!$(this).hasClass('open')) {
            openMobileNavigation();
        } else {
            closeMobileNavigation();
        }
    });
    
});

function openSearchElement() {
    $(searchBlock).slideDown('fast');

    // Change button icon
    $(searchButton).addClass('open');

    // Apply focus on the search field
    $(searchInput).focus();

    // Close mobile navigation if it is open
    closeMobileNavigation();
}

function closeSearchElement() {
    $(searchBlock).slideUp('fast');
    $(searchButton).removeClass('open');
}

function openMobileNavigation() {
    if (!$(mobileNavigationToggle).hasClass('open')) {
        $(navigationList).slideDown('fast');

        // Make the mobile navigation button close the menu on next click
        $(mobileNavigationToggle).addClass('open');
        
        // Close search if it is open and open the mobile navigation
        closeSearchElement();
    }
}

function closeMobileNavigation() {
    if ($(mobileNavigationToggle).hasClass('open')) {
        $(navigationList).slideUp('fast');

        // Make the mobile navigation button open the menu on next click
        $(mobileNavigationToggle).removeClass('open');
    }
}